import React, { useState, useEffect } from 'react';
import CreditsPurchase from './CreditsPurchase';

const CreditBalance: React.FC = () => {
  const [balance, setBalance] = useState<number | null>(null);
  const [showPurchase, setShowPurchase] = useState(false);

  const fetchBalance = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/credits/balance', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setBalance(data.balance);
      }
    } catch (error) {
      console.error('Error fetching balance:', error);
    }
  };

  useEffect(() => {
    fetchBalance();
    
    // Refresh balance every 30 seconds
    const interval = setInterval(fetchBalance, 30000);
    
    return () => clearInterval(interval);
  }, []);

  // Expose fetchBalance globally so enrichment can trigger it
  useEffect(() => {
    (window as any).refreshCreditBalance = fetchBalance;
  }, []);

  return (
    <>
      <button
        onClick={() => setShowPurchase(true)}
        className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200/80 rounded-lg shadow-card hover:bg-blue-100 hover:shadow-card-hover hover:border-blue-300 transition-all duration-200 hover:-translate-y-px"
      >
        <span className="text-sm font-semibold text-gray-600">Credits:</span>
        <span className="text-sm font-bold text-blue-700 tracking-tight">
          {balance !== null ? balance.toLocaleString() : '...'}
        </span>
      </button>
      {showPurchase && (
        <CreditsPurchase
          onClose={() => {
            setShowPurchase(false);
            fetchBalance();
          }}
        />
      )}
    </>
  );
};

export default CreditBalance;
